import axios from "axios";
import application from "./application.js";
import interceptors from "./server-interceptors.js";

// create instance
const instance = axios.create({
    baseURL: application.server || "",
    timeout: 10000,
    autoResult: true
});

// config request interceptor
if (interceptors && interceptors.request) {
    instance.interceptors.request.use(async config => {
        let requestInterceptors = interceptors.request;
        if (typeof requestInterceptors == "function") {
            requestInterceptors = [requestInterceptors];
        }
        for (let i=0; i<requestInterceptors.length; i++) {
            config = await requestInterceptors[i](config, instance);
        }
        return config;
    }, async error => {
        console.info(error);
        let errorInterceptors = interceptors.error;
        if (typeof errorInterceptors == "function") {
            errorInterceptors = [errorInterceptors];
        }
        for (let i=0; i<errorInterceptors.length; i++) {
            error = await errorInterceptors[i](error, instance);
        }
        return error;
    });
}

// config resposne interceptor
if (interceptors && (interceptors.response || interceptors.error)) {
    instance.interceptors.response.use(async response => {
        let config = response.config;
        let responseInterceptors = interceptors.response;
        if (typeof responseInterceptors == "function") {
            responseInterceptors = [responseInterceptors];
        }
        for (let i=0; i<responseInterceptors.length; i++) {
            response = await responseInterceptors[i](response, config, instance);
        }
        return response;
    }, async error => {
        let errorInterceptors = interceptors.error;
        if (typeof errorInterceptors == "function") {
            errorInterceptors = [errorInterceptors];
        }
        for (let i=0; i<errorInterceptors.length; i++) {
            error = await errorInterceptors[i](error, instance);
        }
        return error;
    });
}

export default instance;